class DetailsDisclosure extends HTMLElement {
	constructor() {
		super();
		this.mainDetailsToggle = this.querySelector('details');

		this.addEventListener('keyup', this.onKeyUp);
		document.addEventListener('click', this.onFocusOut.bind(this));
		this.open = this.open.bind(this);
		this.addEventListener('click', this.open);
		this.menuBtns = document.querySelectorAll('.header-top__right .disclosure__button');
		this.menues = document.querySelectorAll('.header-top__right .disclosure__list');
	}

	open() {
		this.menuBtns.forEach(btn => {
			btn.setAttribute("aria-expanded", "false");
		});
		this.menues.forEach(menu => {
			menu.setAttribute("hidden", true);
		});
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== 'ESCAPE') return;

		const openDetailsElement = event.target.closest('details[open]');
		if (!openDetailsElement) return;

		const summaryElement = openDetailsElement.querySelector('summary');
		openDetailsElement.removeAttribute('open');
		summaryElement.focus();
	}

	onFocusOut(e) {
		const withBoundaries = e.composedPath().includes(this.mainDetailsToggle);

		if (!withBoundaries) {
			this.mainDetailsToggle.removeAttribute('open');
		}
	}

	close() {
		this.mainDetailsToggle.removeAttribute('open')
	}
}

customElements.define('details-disclosure', DetailsDisclosure);
